export default __webpack_public_path__ + "images/PD.c2d5763.png";